import { FlightSchema } from '../types/flight';

export const validateFlightData = (data: any): { isValid: boolean; errors: string[] } => {
  const errors: string[] = [];

  // Helper functions
  const isValidDate = (dateStr: string) => {
    const regex = /^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/(19|20)\d\d$/;
    return regex.test(dateStr);
  };

  const isValidTime = (timeStr: string) => {
    const regex = /^(0?[1-9]|1[0-2]):[0-5][0-9]:[0-5][0-9] (AM|PM)$/;
    return regex.test(timeStr);
  };

  // Required fields validation
  const requiredFields = [
    { key: 'contractType', label: 'نوع عقد الطيران' },
    { key: 'iataNumber', label: 'رقم IATA' },
    { key: 'pnrNumber', label: 'رقم PNR' },
    { key: 'arrivalDate', label: 'تاريخ الوصول' },
    { key: 'outboundFlightNumber', label: 'رقم رحلة الذهاب' },
    { key: 'outboundDeparture', label: 'مطار المغادرة' },
    { key: 'outboundArrival', label: 'مطار الوصول' },
    { key: 'outboundArrivalTime', label: 'وقت الوصول' },
    { key: 'returnFlightNumber', label: 'رقم رحلة العودة' },
    { key: 'returnDeparture', label: 'مطار المغادرة للعودة' },
    { key: 'returnDepartureTime', label: 'وقت المغادرة للعودة' },
    { key: 'returnArrival', label: 'مطار الوصول للعودة' },
    { key: 'returnDate', label: 'تاريخ العودة' }
  ];

  for (const field of requiredFields) {
    if (!data[field.key]) {
      errors.push(`${field.label} مطلوب`);
    }
  }

  // Contract type validation
  if (data.contractType && !['B2B', 'B2C'].includes(data.contractType)) {
    errors.push('نوع العقد يجب أن يكون B2B أو B2C');
  }

  // Airport validation
  if (data.outboundArrival && !['Jeddah', 'Madinah', 'Taif'].includes(data.outboundArrival)) {
    errors.push('مطار الوصول يجب أن يكون جدة أو المدينة أو الطائف');
  }

  if (data.returnDeparture && !['Jeddah', 'Madinah', 'Taif'].includes(data.returnDeparture)) {
    errors.push('مطار المغادرة للعودة يجب أن يكون جدة أو المدينة أو الطائف');
  }

  // Date validations
  if (data.arrivalDate && !isValidDate(data.arrivalDate)) {
    errors.push('صيغة تاريخ الوصول يجب أن تكون dd/mm/yyyy');
  }

  if (data.returnDate && !isValidDate(data.returnDate)) {
    errors.push('صيغة تاريخ العودة يجب أن تكون dd/mm/yyyy');
  }

  // Time validations
  if (data.outboundArrivalTime && !isValidTime(data.outboundArrivalTime)) {
    errors.push('صيغة وقت الوصول يجب أن تكون hh:mm:ss AM/PM');
  }

  if (data.returnDepartureTime && !isValidTime(data.returnDepartureTime)) {
    errors.push('صيغة وقت المغادرة للعودة يجب أن تكون hh:mm:ss AM/PM');
  }

  return {
    isValid: errors.length === 0,
    errors
  };
};

export const generateFlightTemplate = (): FlightSchema => {
  return {
    id: '1',
    contractType: 'B2B',
    iataNumber: 'SV',
    pnrNumber: 'SLTLDE',
    arrivalDate: '09/06/2024',
    outboundFlightNumber: 'SV-250',
    outboundDeparture: 'BIRMINGHAM',
    outboundArrival: 'Jeddah',
    outboundArrivalTime: '10:45:00 PM',
    returnFlightNumber: 'SV-253',
    returnDeparture: 'Jeddah',
    returnDepartureTime: '8:10:00 AM',
    returnArrival: 'BIRMINGHAM',
    returnDate: '27/06/2024'
  };
};